import c from 'classnames';
import IconExternalLink from './icons/IconExternalLink';

interface Props {
    href: string;
    children: React.ReactNode;
    className?: string;
}

export default function ExternalLink({ href, children, className }: Props) {
    return (
        <a href={href} target="_blank" rel="noreferrer" className={c('link', className)}>
            {children} <IconExternalLink className="h-5 w-5 inline align-text-bottom hover:underline" />
        </a>
    );
}
